import { useEffect } from 'react';
import { useLoading } from 'src/hooks/useLoading';

const SuspenseProgressBridge: React.FC = () => {
   const { setLoading } = useLoading();

   useEffect(() => {
      setLoading(true);
      return () => setLoading(false);
   }, [setLoading]);

   return null;
};

export default SuspenseProgressBridge;
